import React, {PropTypes} from 'react';
import Button from '../../common/Button';
import '../../../styles/profile/ProfileApiTokenComponent.css';

const ProfileApiToken = ({user, onShow, copy}) => {
  return (
    <div className="col-xs-12 col-sm-9 profile-api-token">
      <div className="border-container col-xs-12">
        <div className="api-header">
          <h2>API Token</h2>
          <div className="page-instructions">
            This is the API token belonging to your account. For more information about this
            token and its use, please {}
            <a href="https://www.osha.gov/injuryreporting/osha_ita_api_documentation_revised.pdf" target="_blank" title="Injury Tracking Application API Documentation - PDF">
              download the API specifications</a> and review <a href="https://www.osha.gov/sites/default/files/ita-api-terms-of-service.pdf" target="_blank" title="Injury Tracking Application API Terms of Service - PDF">
                 the API Terms of Service</a>
          </div>
        </div>
        <div className="api-body">
          <div className="legal-statement">
            <h3>Punishment for Unlawful Statements</h3>
            <div>It is unlawful to make any false statement, representation, or
              certification to an agency of the United States. Violations can be punished by a
              fine or by imprisonment of not more than five years, or by both. See 18 U.S.C.
              1001(a); 29 U.S.C. 666(g).</div>
            <br/>
            <div>By using the API to submit data, you are certifying that the information
              submitted will be true and correct to the best of your knowledge and belief.</div>
          </div>
          <div className="tokenValueContainer">
            <label className="api-token-label">Your API Token
            </label>
            <div className="api-token-box">
              {user.token}
            </div>
            <div>
              <Button
                onClick={onShow}
                className="generate-new-token"
                value="Generate New Token"
                disabled={false}/>
              <Button
                onClick={copy}
                className="generate-new-token"
                value="Copy Token"
                disabled={false}/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ProfileApiToken.propTypes = {
  user: PropTypes.object.isRequired,
  onShow: PropTypes.func.isRequired,
  copy: PropTypes.func.isRequired
};

export default ProfileApiToken;



/** WEBPACK FOOTER **
 ** ./src/components/account/manageAccount/ProfileApiToken.js
 **/